{
  "Empty": "Άδειο"
}
